export default class App {
  uuid: string
  id: string
  name: string
  organizationId: string | null
  isDisabled: boolean

  constructor(json: any = {}) {
    this.uuid = json.uuid
    this.id = json.id
    this.name = json.name ?? ''
    this.organizationId = json.organization_id ?? null
    this.isDisabled = json.archived ?? false
  }
}
